import { useMerch } from "@/services/hooks";

import { Box, Typography } from "@mui/material";

import MerchCard from "@/components/MerchCard";

export default function MerchContainer({ artistKey }) {
  const { data: artistContent } = useMerch(artistKey);

  if (artistContent?.length == 0) {
    return null;
  }

  return (
    <Box sx={{ px: 2 }}>
      <Typography variant="h6" sx={{ mt: 4, fontWeight: 800 }}>
        Merch
      </Typography>
      {artistContent?.length == 0 && (
        <Typography variant="body1" color="darkgray" sx={{ my: 2 }}>
          You'll get an SMS when merch is available.
        </Typography>
      )}

      {artistContent?.length > 0 && (
        <Box
          sx={{
            display: "flex",
            overflowX: "scroll",
            scrollbarWidth: "none" /* Firefox */,
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          {artistContent?.map((content, index) => (
            <Box key={index}>
              <Box
                sx={{ height: "220px", width: "220px", mr: 2, mt: 2, mb: 1 }}
              >
                <MerchCard content={content} />
              </Box>
              <Typography>${content.meta.price}</Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
